export enum RefinancingOutcome {
	Saving = "saving",
	Same = "same",
	Better = "better",
}
